var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-layout"},[_c('div',{staticClass:"position-relative app-wrapper"},[_c('child')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }